// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".minus-navbar-height{height:calc(100% - 60px)}.minus-navbar-height:focus,:focus{outline:none}.bg-transparent-black{background-color:rgba(0,0,0,.7)}", ""]);
// Exports
module.exports = exports;
